import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';
import {
  Card,
  CardActions,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/styles';
import image014 from '../../assets/images/placeholder.png';
import RCD from '../../assets/images/T-3000-RCD-Section-landing.png';
import mpdBackground from '../../assets/images/mpd_background.png';
import { PrintRounded } from '@mui/icons-material';

const images = [image014, mpdBackground, RCD];

const ReportCarouselItem = ({ item, onClick, getReport, printIcon }) => {
  const classes = styles();
  const theme = useTheme();
  const [isDescriptionHidden, setDescriptionHidden] = React.useState(true);
  let placeholderImage = '';
  if (item.header === 'MPD Utilization') {
    placeholderImage = images.find((element) => element.includes('mpd'));
  } else if (item.header === 'RCD (Bearing Assy)') {
    placeholderImage = images.find((element) => element.includes('RCD'));
  } else {
    placeholderImage = images.find((element) =>
      element.includes('placeholder'));
  }

  const handleCardItemClick = () => {
    onClick && onClick(item.id);
  };

  const handleReportGeneration = () => {
    getReport && getReport(item.id);
  };

  return (
    <Card
      component="li"
      onClick={handleCardItemClick}
      sx={{ maxWidth: 345, flexGrow: 1 }}
      className={classes.card}
      key={`filter_card_${item.id}`}
      onMouseEnter={() => setDescriptionHidden(() => false)}
      onMouseLeave={() => setDescriptionHidden(() => true)}
    >
      <Grid item xs={12} className={classes.cardHeaderConatiner}>
      <CardHeader
        title={item.header}
        titleTypographyProps={{ variant: 'h6' }}
      />
      {printIcon && <IconButton onClick={handleReportGeneration}>
          <PrintRounded fontSize='large'/>
      </IconButton>}
      </Grid>
      <CardMedia
        component="img"
        width="90px"
        height="350px"
        image={placeholderImage}
        className={classes.media}
        sx={{ objectFit: 'contain', p: theme.spacing(2) }}
      />
      <Grid className={classes.overlay} hidden={isDescriptionHidden}>
        {item.fields.map((field, i) => (
          <Typography key={`field_${i}`} variant="h6">{field.fieldName}</Typography>
        ))}
      </Grid>
      <CardActions className={classes.footer} />
    </Card>
  );
};

ReportCarouselItem.propTypes = {
  item: PropTypes.object,
  onClick: PropTypes.func,
  getReport: PropTypes.func,
  printIcon: PropTypes.bool
};

export default ReportCarouselItem;
